import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchAllSizeGrps,
  fetchOneSizeGrp,
  createSizeGrp,
  updateSizeGrp,
  deleteSizeGrp,
} from "services/sizegrp";

export const useAllSizeGrps = (filters = {}, enabled = true) => {
  const query = useQuery({
    queryKey: ["all-sizegrps", filters],
    queryFn: () => fetchAllSizeGrps(filters),
    enabled,
  });
  return query;
};

export const useOneSizeGrp = (id, enabled = true) => {
  const query = useQuery({
    queryKey: ["one-sizegrp", id],
    queryFn: () => fetchOneSizeGrp(id),
    enabled: enabled && !!id,
  });
  return query;
};

export const useCreateSizeGrp = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: createSizeGrp,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["all-sizegrps"] });
    },
  });
};

export const useUpdateSizeGrp = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => updateSizeGrp(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["all-sizegrps"] });
      queryClient.invalidateQueries({ queryKey: ["one-sizegrp", variables.id] });
    },
  });
};

export const useDeleteSizeGrp = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: deleteSizeGrp,
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["all-sizegrps"] });
      queryClient.invalidateQueries({ queryKey: ["one-sizegrp", id] });
    },
  });
};
